import { Loader2Icon } from 'lucide-react';
import type { ComponentPropsWithRef, ReactElement } from 'react';
import { cn } from '../util/classes.ts';

export type SpinnerProps = ComponentPropsWithRef<'svg'> & {
    label?: string;
};

export function Spinner({ className, label = 'Loading', ...props }: SpinnerProps): ReactElement {
    return (
        <Loader2Icon
            data-slot="spinner"
            role="status"
            aria-label={label}
            className={cn('size-4 animate-spin', className)}
            {...props}
        />
    );
}
